var map = {
	"./command_2.png": "e2a7",
	"./command_3.png": "254e",
	"./command_4.png": "8636",
	"./command_5.png": "77f6",
	"./command_6.png": "f3e3",
	"./command_7.png": "5c91",
	"./command_8.png": "0645"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3ab3";